import CreateCategoryPage from "./CreateCategoryPage";

export default CreateCategoryPage;
